import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage/HomePage";
import AboutPage from "./pages/AboutPage/AboutPage";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import ContactPage from "./pages/ContactPage/ContactPage";
import Careers from "./pages/Careers/Careers";
import CareerOverview from "./pages/CareerOverview/CareerOverview";
import TestPage from "./pages/TestPage/TestPage";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import EventsPage from "./pages/EventsPage/EventsPage";
import MenuPage from "./pages/MenuPage/MenuPage";

// ✅ Import tracker
import AnalyticsTracker from "./components/AnalyticsTracker";

const App = () => {
  return (
    <BrowserRouter>
      {/* ✅ Add this line */}
      <AnalyticsTracker />

      <ScrollToTop />
      <Navbar />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/career-overview/:id" element={<CareerOverview />} />
        {/* <Route path="/test" element={<TestPage />} /> */}
      </Routes>

      <Footer />
    </BrowserRouter>
  );
};

export default App;